import axios from "axios";
import { API_BASE_URL } from "../config";

// Helper function to handle logging only in development
const isDevelopment = process.env.NODE_ENV === 'development';
const debugLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

const debugError = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

// Create axios instance with default config
const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Add request interceptor with conditional logging
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Log outgoing request only in development
    debugLog("Outgoing request:", {
      url: config.url,
      method: config.method,
      baseURL: config.baseURL,
      hasToken: !!token,
    });

    return config;
  },
  (error) => {
    debugError("Request interceptor error:", error);
    return Promise.reject(error);
  }
);

// Enhanced response interceptor with conditional logging
instance.interceptors.response.use(
  (response) => {
    // Log successful responses only in development
    debugLog("Response received:", {
      status: response.status,
      url: response.config.url,
      method: response.config.method,
      hasData: !!response.data,
    });
    return response;
  },
  (error) => {
    // Detailed error logging only in development
    debugError("API Error:", {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      url: error.config?.url,
      method: error.config?.method,
      baseURL: error.config?.baseURL,
      fullUrl: `${error.config?.baseURL}${error.config?.url}`,
    });

    if (error.response?.status === 401) {
      // Keep this log only if necessary for production, otherwise use debugLog
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default instance;